import Vue from 'vue'
import Router from 'vue-router'
import About from '@/views/about'
import Bottom from '@/views/bottom'
import Serve from '@/views/serve'
import Add from '@/views/add'
import News from '@/views/news'
import Base from '@/views/base'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/',
    routes: [{
        path: '/',
        name: 'base',
        component: Base
    }, {
        path: '/news',
        name: 'news',
        component: News
    }, {
        path: '/about',
        name: 'about',
        component: About
    }, {
        path: '/serve',
        name: 'Serve',
        component: Serve
    }, {
        path: '/bottom',
        name: 'bottom',
        component: Bottom
    }, {
        path: '/quick',
        name: 'quick',
        component: () => {
            import ('@/views/quick.vue')
        }
    }, {
        path: '/add',
        name: 'Add',
        component: Add
    }, ]
})


// WEBPACK FOOTER //
// ./src/router/index.js